import React from 'react';
import { Grid } from '@mui/material';

import RouteWrapper from './RouteWrapper';
import RatingsByRoundChart from '../components/charts/RatingsByRoundChart';
import MatchHistoryTable from '../components/tables/MatchHistoryTable';

import PlayerData from '../components/widgets/PlayerData';
import RecentForm from '../components/widgets/RecentForm';
import StreakData from '../components/widgets/StreakData';
import PlacePercentages from '../components/widgets/PlacePercentages';
import RoundOutcomePercentages from '../components/widgets/RoundOutcomePercentages';
import LastRound from '../components/widgets/LastRound';
import { RoundWindowProvider } from '../components/shared/RoundWindow';

const Home = () => (
    <RouteWrapper>
        <RoundWindowProvider>
            {/* Identity, rating headline and season KPIs */}
            <PlayerData />

            {/* How am I playing right now? */}
            <RecentForm />
            <StreakData />
            <LastRound />

            {/* How did I get here? */}
            <RatingsByRoundChart />

            {/* How do my rounds usually go? */}
            <RoundOutcomePercentages />
            <PlacePercentages />

            <MatchHistoryTable />
            <Grid item xs={12} sx={{ mb: 6 }} />
        </RoundWindowProvider>
    </RouteWrapper>
);

export default Home;
